import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";
import {markRaw} from 'vue'
import FormattedTime from 'frontend/common/formatted-time.vue'

export const DriverCategoryDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name',
    'background_color',
    'border_color',
    'font_color',
    'updated_at'
  ],
  subscriptions: {
    items: 'DriverCategoriesChannel',
  },
  defaultColumns: [
    'name',
    'label'
  ],
  columnConfig: {
    name: {
      label: 'Name',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
        class: 'text-nowrap',
      },
    },
    label: {
      label: 'Label',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'component',
        component: 'erebus-label',
        componentProps: c => ({ item: c }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
        }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
  }
}